var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { GeofenceType, } from '@tenderd/schema';
import { HEREMap, MapBound, Marker, Polygon, useService, } from '@tenderd/track-web-utils';
import { Modal, message } from 'antd';
import omit from 'lodash/omit';
import React, { useEffect, useState } from 'react';
import { REFRESH_EQUIPMENT_LIST_TIMEOUT } from '../../../../constants/Constants';
import { getTrackingIcon } from '../../../../constants/Icons';
import { useGroupService } from '../../../../providers/GroupServiceProvider';
import { i18n } from '../../../../translations';
import { GroupSettingsPageTKeys } from '../../../../translations/keys';
import { GroupGeofenceMode, useGroupGeofencePageContext, } from '../../GroupGeofencePage.context';
import { LocationMarkers } from './LocationMarkers/LocationMarkers';
import LocationSearchInput from './LocationSearchInput';
import PolygonDraw from './PolygonDraw/PolygonDraw';
var confirm = Modal.confirm;
var GeofenceMap = function () {
    var context = useGroupGeofencePageContext();
    var _a = __read(useState([]), 2), deviceLocations = _a[0], setDeviceLocations = _a[1];
    var service = useService();
    var groupService = useGroupService();
    var _b = __read(useState([]), 2), points = _b[0], setPoints = _b[1];
    var getData = function (refreshApi) {
        if (refreshApi === void 0) { refreshApi = false; }
        return service.server
            .getDevicesByGroups(groupService.group.id)
            .then(function (res) {
            setDeviceLocations(res.filter(function (a) { return a.location; }));
        })
            .catch(function (err) {
            !refreshApi && message.error(err.message);
        });
    };
    useEffect(function () {
        getData();
    }, []);
    useEffect(function () {
        if (groupService.group.id) {
            var interval_1;
            interval_1 = setInterval(function () {
                getData(true);
            }, REFRESH_EQUIPMENT_LIST_TIMEOUT);
            return function () {
                clearInterval(interval_1);
            };
        }
    }, [groupService.group.id]);
    useEffect(function () {
        var _a;
        var geofence = (_a = context.selectedGeofence) === null || _a === void 0 ? void 0 : _a.geofence;
        if (geofence && geofence.length) {
            setPoints(geofence.map(function (c) { return ({ lat: c.lat, lon: c.lon }); }));
        }
        else {
            setPoints(context.geofences.data.length &&
                context.geofences.data[0].geofence.map(function (c) { return ({
                    lat: c.lat,
                    lon: c.lon,
                }); }));
        }
    }, [context.selectedGeofence, context.geofences]);
    var onSetGeofence = function (geofence) {
        if (!context.selectedGeofence)
            return;
        var payload = __assign(__assign({}, context.selectedGeofence), { geofence: geofence.map(function (c) { return ({ lat: c[0], lon: c[1] }); }) });
        service.server
            .updateGroupGeofence(context.selectedGeofence._id, omit(payload, ['_id', 'locationMarkers']))
            .then(function () {
            context.updateGeofenceData('update', payload);
            context.setSelectedGeofence(payload);
            context.setMode(undefined);
        });
    };
    return (React.createElement(HEREMap, { fullScreen: false },
        context.mode !== GroupGeofenceMode.Geofence && (React.createElement("div", { style: {
                position: 'absolute',
                top: 15,
                right: 15,
                width: 300,
                zIndex: 1,
            } },
            React.createElement(LocationSearchInput, null))),
        React.createElement(PolygonDraw, { onSuccess: function (geofence) {
                confirm({
                    title: "".concat(i18n.t(GroupSettingsPageTKeys.wantToSaveGeofence)),
                    icon: React.createElement(ExclamationCircleOutlined, null),
                    content: i18n.t(GroupSettingsPageTKeys.saveGeofence),
                    onOk: function () {
                        onSetGeofence(geofence);
                    },
                    onCancel: function () {
                        context.setMode(undefined);
                    },
                });
            } }),
        React.createElement(MapBound, { points: points }),
        React.createElement(LocationMarkers, null),
        deviceLocations.map(function (eq, index) {
            var filter = '';
            if (eq.ignition_status && eq.speed > 5) {
                filter =
                    'invert(64%) sepia(37%) saturate(788%) hue-rotate(93deg) brightness(94%) contrast(91%)';
            }
            else if (eq.ignition_status && eq.speed <= 5) {
                filter =
                    'invert(86%) sepia(74%) saturate(2487%) hue-rotate(360deg) brightness(113%) contrast(99%)';
            }
            else if (!eq.ignition_status) {
                filter =
                    'invert(31%) sepia(40%) saturate(5751%) hue-rotate(347deg) brightness(117%) contrast(81%)';
            }
            return (React.createElement(Marker, { lat: eq.location.coordinates[0], lng: eq.location.coordinates[1], key: index },
                React.createElement("div", { className: "machine-marker" },
                    React.createElement("div", null,
                        React.createElement("div", { className: "machine-marker-icon" },
                            React.createElement("img", { style: { height: 20, width: 20 }, src: getTrackingIcon(eq.equipment_type) })),
                        React.createElement("img", { alt: "direction indicator", src: "https://storage.googleapis.com/tenderd-ui/assets/direction-indicator-black.png", className: "machine-marker-direction-indicator", style: {
                                transform: "rotate(".concat(eq.direction || 0, "deg)"),
                                filter: filter,
                            } })))));
        }),
        context.geofences.data
            .filter(function (geofence) {
            var _a;
            return geofence.geofence.length &&
                (context.mode === GroupGeofenceMode.Geofence
                    ? geofence._id !== ((_a = context.selectedGeofence) === null || _a === void 0 ? void 0 : _a._id)
                    : true);
        })
            .map(function (geofence) {
            var _a, _b;
            var isRestricted = geofence.type === GeofenceType.Restricted;
            return (React.createElement(Polygon, { polygon: geofence.geofence.map(function (c) { return ({
                    lat: c.lat,
                    lng: c.lon,
                }); }), key: geofence._id, strokeColor: ((_a = context.selectedGeofence) === null || _a === void 0 ? void 0 : _a._id) === geofence._id
                    ? isRestricted
                        ? '#FF0000'
                        : '#1677FF'
                    : '#B3B3B3', fillColor: ((_b = context.selectedGeofence) === null || _b === void 0 ? void 0 : _b._id) === geofence._id
                    ? isRestricted
                        ? 'rgba(244, 67, 54, 0.5)'
                        : 'rgba(181, 217, 239, 0.5)'
                    : 'rgba(179, 179, 179, 0.5)', label: geofence.name, showLabelOnHover: true }));
        })));
};
export default GeofenceMap;
